import React from 'react';

// TAM AL-JANUB PAGE
export const tamAljanubContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #c31432 0%, #240b36 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Restaurant
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'Tam Al-Janub', size: 'h1' },
        {
          type: 'text',
          content: 'A traditional restaurant in Jeddah since the late 70s. Built the website with a digital menu, QR codes for each branch, and bilingual Arabic–English support.',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <a
                href="https://aljanubrestaurant.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: '#19293d',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600'
                }}
              >
                Visit Live
              </a>
              <span style={{
                background: 'var(--bg-accent)',
                color: 'var(--text-accent)',
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600'
              }}>
                Live
              </span>
            </div>
          )
        }
      ]
    },

    // LIVE EMBED
    {
      id: 'live-demo',
      title: 'The Website',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              position: 'relative',
              width: '100%',
              height: '80vh',
              minHeight: '600px',
              background: '#000',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              border: '2px solid var(--border-color)'
            }}>
              <iframe
                src="https://aljanubrestaurant.com"
                title="Al-Janub Restaurant"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
              />
            </div>
          )
        }
      ]
    },

    // TECH STACK
    {
      id: 'stack',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => {
            const stack = [
              { name: 'HTML / CSS / JavaScript', color: '#E44D26', bg: 'rgba(228, 77, 38, 0.08)' },
              { name: 'Firebase Hosting', color: '#FFCA28', bg: 'rgba(255, 202, 40, 0.08)' },
              { name: 'JSON Menu System', color: '#6366f1', bg: 'rgba(99, 102, 241, 0.08)' },
              { name: 'Bilingual AR / EN', color: '#10b981', bg: 'rgba(16, 185, 129, 0.08)' },
              { name: 'QR Code Generation', color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.08)' },
            ];

            return (
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px'
              }}>
                {stack.map((tech) => (
                  <span
                    key={tech.name}
                    style={{
                      background: tech.bg,
                      border: `1px solid ${tech.color}22`,
                      color: tech.color,
                      padding: '10px 20px',
                      borderRadius: '10px',
                      fontSize: '0.9rem',
                      fontWeight: '600',
                      letterSpacing: '0.01em',
                      backdropFilter: 'blur(8px)'
                    }}
                  >
                    {tech.name}
                  </span>
                ))}
              </div>
            );
          }
        }
      ]
    }
  ],

  callToAction: {
    brand: { bg: "#16293D", fg: "#F2EBDD", btnBg: "#FFCA28", btnFg: "#16293D", logo: "/brand-logos/tam-aljanub-navy.png", logoWidth: 132, logoRadius: 0, flat: true },
    title: 'Tam Al-Janub',
    text: 'A Jeddah restaurant since the late 70s',
    button: { text: 'Visit the Website', url: 'https://aljanubrestaurant.com' }
  }
};
